import { TextMediumSM } from "../../../../../Components/Text/MediumText"
import TaskStatus from "./TaskStatus";


const Task = () =>{
    return(
        <>
        <TextMediumSM content="Task" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <TaskStatus/>
         </div>
         </div>
         </>
    )
}

export default Task;